import { render, staticRenderFns } from "./workbooks.vue?vue&type=template&id=2dedf235"
import script from "./workbooks.vue?vue&type=script&lang=js"
export * from "./workbooks.vue?vue&type=script&lang=js"
import style0 from "./workbooks.vue?vue&type=style&index=0&id=2dedf235&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports